import { render, staticRenderFns } from "./GamesSetup.vue?vue&type=template&id=90b46e66&scoped=true"
import script from "./GamesSetup.vue?vue&type=script&lang=js"
export * from "./GamesSetup.vue?vue&type=script&lang=js"
import style0 from "./GamesSetup.vue?vue&type=style&index=0&id=90b46e66&prod&lang=scss"
import style1 from "./GamesSetup.vue?vue&type=style&index=1&id=90b46e66&prod&lang=scss&scoped=true"
import style2 from "./GamesSetup.vue?vue&type=style&index=2&id=90b46e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b46e66",
  null
  
)

export default component.exports